import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";

const AddSeries = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    id: null,
    name: "",
  });

  const onSave = () => {
    if (formValue.name) {
      setError(false);
      setLoading(true);
      var formData = new FormData();
      formData.append("name", formValue.name);
      formData.append("id", formValue.id);
      const pUrl = id ? API_URL.SERIES_UPDATE : API_URL.SERIES_SAVE;
      axios
        .post(pUrl, formData)
        .then((res) => {
          setLoading(false);
          setError(false);
          if (res.data.status === 1) {
            let message = id
              ? "Series Updated Successfully."
              : "Series Created Successfully.";
            toast.success(message, {
              autoClose: 3000,
              position: "top-right",
            });
            setLoading(false);
            navigate("/admin/series");
          } else {
            toast.error(res.data.data, {
              autoClose: 3000,
              position: "top-right",
            });
          }
        })
        .catch(() => {
          setError(false);
          setLoading(false);
        });
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.SERIES_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormValue({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formValue[key];
  };

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} Series</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>
                    Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formValue.name}
                    className={
                      isRequiredField("name")
                        ? "form-control required"
                        : "form-control"
                    }
                    placeholder=""
                    id="name"
                    onChange={(event) => {
                      setFormValue({ ...formValue, name: event.target.value });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
              <div className="text-end">
                <Link
                  to={"/admin/series"}
                  className={
                    loading
                      ? "btn btn-danger btn-sm me-2 disabled-link"
                      : "btn btn-danger btn-sm me-2"
                  }
                  onClick={(e) => loading && e.preventDefault()}
                >
                  Cancel
                </Link>
                <button
                  type="button"
                  onClick={onSave}
                  disabled={loading}
                  className="btn btn-primary btn-sm"
                >
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    {loading && (
                      <Watch color={"white"} height={15} width={15} />
                    )}
                    Submit
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddSeries;
